import InteractiveAnnotation from "./interactiveAnnotation";
import { POINTER_CLASSES } from "../../config/config";
import { drawBox } from "../canvasUtils";
import { isInBoundsBox } from "../geometry";
export default class Redaction extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);

    this.x = position.x;
    this.y = position.y;
    this.height = 40;
    this.width = 100;

    this.backgroundColor = "black";

    this.activeBody = false;
    // active sides ORs the boxSides flag below to represent selection of a side or corner
    this.activeSides = 0;
    this.boxSides = {
      top: 1,
      left: 2,
      right: 4,
      bottom: 8
    };
  }

  get isActive() {
    return this.activeBody || this.activeSides;
  }

  draw(ctx) {
    ctx.fillStyle = this.backgroundColor;
    ctx.fillRect(this.x, this.y, this.width, this.height);

    if (this.isActive) this.drawInteractionBoxes(ctx);
  }

  drawInteractionBoxes(ctx) {
    const boxes = this.getBoxes();
    for (let i = 0; i < boxes.length; i++) {
      const box = boxes[i];
      drawBox(ctx, box.x, box.y, this.transform.zoom);
    }
  }

  getBoxes() {
    return [
      {
        x: this.x,
        y: this.y,
        side: this.boxSides.top | this.boxSides.left,
        hoverClass: this.flipCorners() ? POINTER_CLASSES.neswResize : POINTER_CLASSES.nwseResize
      },
      {
        x: this.x + this.width / 2,
        y: this.y,
        side: this.boxSides.top,
        hoverClass: POINTER_CLASSES.nsResize
      },
      {
        x: this.x + this.width,
        y: this.y,
        side: this.boxSides.top | this.boxSides.right,
        hoverClass: this.flipCorners() ? POINTER_CLASSES.nwseResize : POINTER_CLASSES.neswResize
      },
      {
        x: this.x,
        y: this.y + this.height / 2,
        side: this.boxSides.left,
        hoverClass: POINTER_CLASSES.ewResize
      },
      {
        x: this.x + this.width,
        y: this.y + this.height / 2,
        side: this.boxSides.right,
        hoverClass: POINTER_CLASSES.ewResize
      },
      {
        x: this.x,
        y: this.y + this.height,
        side: this.boxSides.bottom | this.boxSides.left,
        hoverClass: this.flipCorners() ? POINTER_CLASSES.nwseResize : POINTER_CLASSES.neswResize
      },
      {
        x: this.x + this.width / 2,
        y: this.y + this.height,
        side: this.boxSides.bottom,
        hoverClass: POINTER_CLASSES.nsResize
      },
      {
        x: this.x + this.width,
        y: this.y + this.height,
        side: this.boxSides.bottom | this.boxSides.right,
        hoverClass: this.flipCorners() ? POINTER_CLASSES.neswResize : POINTER_CLASSES.nwseResize
      }];
  }

  flipCorners() {
    return (this.width > 0) !== (this.height > 0);
  }

  isInBounds(x, y) {
    return this.isInBoundsBody(x, y) || this.getHoveredBox(x, y);
  }

  isInBoundsBody(x, y) {
    return this.isBetween(x, this.x, this.x + this.width)
      && this.isBetween(y, this.y, this.y + this.height);
  }

  isBetween(value, bound1, bound2) {
    const min = Math.min(bound1, bound2);
    const max = Math.max(bound1, bound2);
    return value >= min && value <= max;
  }

  mousedown(x, y) {
    super.mousedown(x, y);
    let box = this.getHoveredBox(x, y);
    this.activeSides = box && box.side;
    this.activeBody = !box;
    this.signalReady();
  }

  getHoveredBox(x, y) {
    const boxes = this.getBoxes();
    for (let i = 0; i < boxes.length; i++) {
      const box = boxes[i];
      if (isInBoundsBox(x, y, box.x, box.y, this.transform.zoom)) return box;
    }
    return null;
  }

  mousemove(x, y) {
    if (this.activeBody) this.updateBody(x, y);
    else if (this.activeSides) this.updateSides(x, y);
    this.signalReady();
  }

  updateBody(x, y) {
    const { dx, dy } = this.getAndUpdateInteraction(x, y);
    this.x = this.x + dx;
    this.y = this.y + dy;
  }

  updateSides(x, y) {
    const { dx, dy } = this.getAndUpdateInteraction(x, y);
    if (this.updatingTop()) this.updateTop(dy);
    if (this.updatingLeft()) this.updateLeft(dx);
    if (this.updatingRight()) this.updateRight(dx);
    if (this.updatingBottom()) this.updateBottom(dy);
  }

  updatingTop() {
    return this.updatingSide(this.boxSides.top);
  }

  updatingLeft() {
    return this.updatingSide(this.boxSides.left);
  }

  updatingRight() {
    return this.updatingSide(this.boxSides.right);
  }

  updatingBottom() {
    return this.updatingSide(this.boxSides.bottom);
  }

  updatingSide(side) {
    return (this.activeSides & side) === side;
  }

  updateTop(dy) {
    this.y += dy;
    this.height -= dy;
  }

  updateLeft(dx) {
    this.x += dx;
    this.width -= dx;
  }

  updateRight(dx) {
    this.width += dx;
  }

  updateBottom(dy) {
    this.height += dy;
  }

  deactivate() {
    this.activeBody = false;
    this.activeSides = 0;
    this.signalReady();
  }

  getHoverClass(x, y) {
    let box = this.getHoveredBox(x, y);
    if (box) return box.hoverClass;
    return POINTER_CLASSES.pointer;
  }
}